import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail, setDetailParams } from "../../state/flrnSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";


const CreateFlrnMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { detailParams, isNewEntry } = useSelector((state) => state.flrn);
  const [submitBtnId, setSubmitBtnId] = useState("")
  const submitLockRef = useRef(false);//
  const [formData, setFormData] = useState({
    Flrn_Code: "",
    Flrn_Name: "",
    Flrn_Group: "",
    Flrn_Ord: "",
  });

  const { data: flrnDetails = [], isPending: isLoading, mutate: filterDetail } = usePost({
    url: apiRoute.flrn.getFlrnForUpdate,
    queryKey: "fetchFlrnbyId",
  });


  // Fetch data when `detailParams?.Flrn_Code` exists
  useEffect(() => {
    if (detailParams && Object.keys(detailParams).length > 0) {

      filterDetail({
        data: {
          Flrn_Code: detailParams.Flrn_Code
        }
      })
    }
  }, [detailParams]);

  useEffect(() => {
    if (!isNewEntry && flrnDetails && Object.keys(flrnDetails).length > 0) {
      setFormData({
        Flrn_Code: flrnDetails.Flrn_Code || "",
        Flrn_Name: flrnDetails.Flrn_Name || "",
        Flrn_Group: flrnDetails.Flrn_Group || "",
        Flrn_Ord: flrnDetails.Flrn_Ord || ""
      });
      console.log(flrnDetails.Flrn_Code, isNewEntry, formData)

    }
  }, [flrnDetails]);



  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const { mutate: addUpdateFlrn, isPending, isError } = usePost({
    queryKey: "Flrn",
    url: apiRoute.flrn.AddUpdateFlrn,
    successMessage: "Flrn saved successfully!",
    onSuccessTasks: () => {
      dispatch(resetDetail());
      submitLockRef.current = false;
      if (submitBtnId == 'btnSaveNew') {
        setFormData({
          Flrn_Code: "",
          Flrn_Name: "",
          Flrn_Group: "",
          Flrn_Ord: "",
        })
      }
      else
        navigate(linksUrl.diamondParamater.flrn.flrnMaster);
    },
  });

  const onSuccessChkDupCode = (data) => {
    let isDuplicate = 0
     if (!submitLockRef.current) return; // 
    if (isNewEntry && data && data.length > 0) {
      if (data[0].count > 0) {
        if (!toast.isActive("toast_chkflrnid")) {
          toast.error(`Duplicate FLRN Code Found`, {
            "position": "top-center",
            "className": "toast-error",
            toastId: "toast_chkflrnid"
          })
        }
        isDuplicate = 1
        setFormData({...formData,Flrn_Code:""})
        submitLockRef.current = false;
      }
    }
    if (isDuplicate === 0) {
      addUpdateFlrn({
        data: {
          ...formData,
          UID: user.username,
          pRecStatus: 2,
        }
      });

    }
  }
  const { mutate: funCheckDuplicateFlrnCode } = usePost({
    queryKey: "checkFlrnCode",
    url: apiRoute.flrn.checkFlrnCode,
    onSuccessTasks: onSuccessChkDupCode
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitBtnId(e.nativeEvent.submitter.id)
    if (!formData.Flrn_Code.trim() || !formData.Flrn_Name.trim()) {
      toast.warn("Flrn_Code and Flrn_Name are required.");
      return;
    }
 if (submitLockRef.current) return;
    submitLockRef.current = true;
    if (isNewEntry) {
      funCheckDuplicateFlrnCode({
        data: {
          Flrn_Code: formData.Flrn_Code
        }
      })
    }
    if (!isNewEntry) {
      addUpdateFlrn({
        data: {
          ...formData,
          UID: user.username,
          pRecStatus: 1,
        }
      });
    }

  };

  const { data: ordData = [] } = useFetchWithBody({
    url: apiRoute.flrn.getNextFlrnOrd,
    queryKey: "getNextFlrnOrd",
  });


  useEffect(() => {
    if (isNewEntry) {
      setFormData((prev) => ({
        ...prev,
        Flrn_Ord: ordData.NextFlrnOrd,
      }));
    }
  }, [isNewEntry, ordData]);
  if (isError) {
    return <ErrorCard />
  }
  if (isLoading || isPending) {
    return <LoadingCard />
  }

  return (
    <MainContainer
      pageName="Flrn Entry"
      breadcrumbs={["Diamond Parameter", "Flrn Master"]}
      prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.flrn.flrnMaster) }}
    >
      <Card className="p-6">
        <CardBody>

          <form onSubmit={handleSubmit}>
            <div className="grid gap-4">
              <Input label="Flrn Code" size="sm" maxLength={6}
                readOnly={isNewEntry ? false : true} name="Flrn_Code" value={formData.Flrn_Code} onChange={handleChange} isRequired />
                <h2 className="text-red-300 " style={{fontSize:"0.7rem"}}>Flrn code cannot be longer than 6 characters</h2>
              <Input label="Flrn Name" size="sm" name="Flrn_Name" value={formData.Flrn_Name} onChange={handleChange} isRequired />
              <Input label="Flrn Group" size="sm" name="Flrn_Group" value={formData.Flrn_Group} onChange={handleChange} />
              <Input label="Flrn Order" size="sm" name="Flrn_Ord" type="number" value={formData.Flrn_Ord} onChange={handleChange} />
              <div className="flex gap-4 justify-center">
                <Button type="submit" size="sm" id="btnSave" color="primary" isLoading={isPending}
                className="uppercase font-semibold"
                >
                  {isNewEntry ? "Save" : "Update"}
                </Button>
                <Button
                  id="btnSaveNew"
                  color="success"
                  type="submit"
                  size="sm"
                  variant="shadow"
                  className="text-white uppercase font-semibold"
                  startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                >
                  Save & New
                </Button>
              </div>

            </div>
          </form>

        </CardBody>
      </Card>
    </MainContainer>
  );
};

export default CreateFlrnMaster;

